import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'index',
	  component: () => import('../views/index.vue')
	},
	{
	  path: '/newpay',
	  name: 'newpay',
	  component: () => import('../views/newpay.vue')
	},
	{
	  path: '/alypay',
	  name: 'alypay',
	  component: () => import('../views/alypay.vue')
	},
	{
	  path: '/btnpay',
	  name: 'btnpay',
	  component: () => import('../views/btnpay.vue')
	},
	{
	  path: '/outline',
	  name: 'outline',
	  component: () => import('../views/outline.vue')
	},
	{
	  path: '/success',
	  name: 'success',
	  component: () => import('../views/success.vue')
	},
	{
	  path: '/show',
	  name: 'show',
	  component: () => import('../views/show.vue')
	},
	{
	  path: '/queding',
	  name: 'queding',
	  component: () => import('../views/queding.vue')
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
